

<template>
  <div class="currentYearIndex">
    <div v-loading="isLoading">
      <!-- <el-tabs v-model="moneyActiveName" type="card" @tab-click="handleClick">
        <el-tab-pane :class="[classPlat==true?'is-nodata':'']"  v-if="allowedPlatIds.includes('1')" label="OPPO" name="1"></el-tab-pane>
        <el-tab-pane :class="[classPlat==true?'is-nodata':'']" v-if="allowedPlatIds.includes('3')" label="vivo" name="3"></el-tab-pane>
        <el-tab-pane :class="[classPlat==true?'is-nodata':'']" v-if="allowedPlatIds.includes('4')" label="小米" name="7"></el-tab-pane>
        <el-tab-pane :class="[classPlat==true?'is-nodata':'']" v-if="allowedPlatIds.includes('7')"  label="华为" name="4"></el-tab-pane>
      </el-tabs>-->

      <div class="yearAll">
        <div class="yearBtn" v-for="(item,index) in platArr" :key="index">
          <el-button
            v-if="allowedPlatIds.includes(item.id)"
            :class="[moneyActiveName==item.id?'active':'', item.classPlat==true?'is-nodata':'is-havedata']"
            type="button"
            @click="handleClick(item.id,index)"
          >{{item.label}}</el-button>
        </div>
      </div>

      <div class="outerYear">
        <el-row :gutter="20">
          <el-col :span="20">
            <div class="yearBtn">
              <span v-for="(item,index) in yearArr" :key="index">
                <el-button
                  v-if="Number(item.id)<=Number(new Date().getFullYear())"
                  :class="[currentYear==item.id?'active':'',item.classiYear==true?'is-nodata':'is-havedata']"
                  type="button"
                  @click="getYearVal(item.id,index)"
                >{{item.label}}</el-button>
              </span>
            </div>
          </el-col>
          <el-col :span="4" class="tar jdgl">
            <span v-if="pageFuncNames.includes('get_compete_plat_username')" v-matomo="{behaviorCategory: `竞代数据管理(${platName})`,  name: '竟代管理' }"  @click="jdglFn">竞代管理</span>
          </el-col>
        </el-row>
      </div>
      <div class="outerMonth mt15">
        <div class="MonthBtn">
          <el-button
            v-for="(item,index) in monthArr"
            :key="index"
            :class="[currentMonth==item.id?'active':'',item.classMonth==true?'is-nodata':'is-havedata']"
            type="button"
            @click="getMonthVal(item.id,index)"
          >{{item.label}}</el-button>
        </div>
      </div>
      <Calendar
        :platName="platName"
        :platId="moneyActiveName"
        :calendarValue="range_time"
        :calendarList="listData"
        :monthDate="mydata.month_not_cost_date"
        :pageFuncNames="pageFuncNames"
        @upDataList="allowedPlatIdsFn"
      ></Calendar>
      <JDGLLIST :platName="platName" ref="jdglListRef" @upDataList="allowedPlatIdsFn" :pageFuncNames="pageFuncNames"></JDGLLIST>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Calendar from "@/views/dataCenter/competeManage/components/calendar";
import JDGLLIST from "./components/jdgllist";
import { pageMixin } from "../../mixins/pageMixin";

import API from "@/api/competeManage.js";
import _ from "lodash";

export default {
  name: "CompeteManage",
  mixins: [pageMixin],
  components: {
    // Layout,
    Calendar,
    JDGLLIST
  },
  data() {
    return {
      isLoading: true,
      currentYear: new Date().getFullYear(), // 当前年
      currentMonth: new Date().getMonth() + 1, // 当前月
      range_time: [], // 当前时间['2022-11-14','2022-11-15']
      listData: [], // 日历数据
      classiYear: false, // 年
      classMonth: false, // 月
      classPlat: false, // 渠道
      platArr: [
        { id: "1", label: "OPPO" },
        { id: "3", label: "vivo" },
        { id: "4", label: "华为" },
        { id: "7", label: "小米" }
      ],

      yearArr: [
        {
          id: "2020",
          label: "2020年"
        },
        {
          id: "2021",
          label: "2021年"
        },
        {
          id: "2022",
          label: "2022年"
        },
        {
          id: "2023",
          label: "2023年"
        },
        {
          id: "2024",
          label: "2024年"
        },
        {
          id: "2025",
          label: "2025年"
        },
        {
          id: "2026",
          label: "2026年"
        },
        {
          id: "2027",
          label: "2027年"
        },
        {
          id: "2028",
          label: "2028年"
        },
        {
          id: "2029",
          label: "2029年"
        },
        {
          id: "2030",
          label: "2030年"
        },
        {
          id: "2031",
          label: "2031年"
        }
      ], //年数组
      monthArr: [
        {
          id: "1",
          label: "1月"
        },
        {
          id: "2",
          label: "2月"
        },
        {
          id: "3",
          label: "3月"
        },
        {
          id: "4",
          label: "4月"
        },
        {
          id: "5",
          label: "5月"
        },
        {
          id: "6",
          label: "6月"
        },
        {
          id: "7",
          label: "7月"
        },
        {
          id: "8",
          label: "8月"
        },
        {
          id: "9",
          label: "9月"
        },
        {
          id: "10",
          label: "10月"
        },
        {
          id: "11",
          label: "11月"
        },
        {
          id: "12",
          label: "12月"
        }
      ], // 月数组
      mydata: {
        year_not_cost_date: [], // 年无竞代
        month_not_cost_date: [], // 月无竞代
        plat_not_cost: [] //渠道-无数据
      }, //  返回标色数据
      moneyActiveName: "" //默认渠道
    };
  },

  computed: {
    ...mapGetters(["name"]),
    platName() {
      const data = _.find(this.platArr, { id: this.moneyActiveName });
      if (data) {
        return data.label
      }else {
        return '';
      }
    },
    allowedPlatIds() {
      return this.allowedPlatList.map(item => item.id);
    },
    pageFuncNames() {
      return this.pageFunc.map(item => item.name);
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.allowedPlatIdsFn();
  },

  methods: {
    // 渠道颜色处理

    platColor(platdata) {
      this.platArr.forEach(el => {
        el.classPlat = platdata.includes(Number(el.id));
      });
    },

    // 年颜色处理
    yearColor(yeardata) {
      this.yearArr.forEach(el => {
        el.classiYear = yeardata.includes(Number(el.id));
      });
    },

    // 月颜色处理
    monthColor(monthdata) {
      this.monthArr.forEach(el => {
        el.classMonth = monthdata.includes(el.id);
      });
    },

    //   mixin方法
    initPageStates() {
      this.allowedPlatIdsFn();
    },
    //   鉴权
    allowedPlatIdsFn(val) {
      if (val) {
        // 判定权限编辑是否更改渠道-有渠道更新
        let plat_id = val.plat_id;
        if (this.allowedPlatIds.length != 0) {
          if (plat_id && this.allowedPlatIds.includes(plat_id)) {
            this.moneyActiveName = plat_id;
          } else {
            this.moneyActiveName = this.allowedPlatIds[0];
          }
            this.getCompeteDataList();
        }
      } else {
           // 判定权限编辑是否更改渠道-无渠道更新-默认第一个
        if (this.allowedPlatIds.length != 0) {
          this.moneyActiveName = this.allowedPlatIds[0];
            this.getCompeteDataList();
        }
      }
    
    },

    // 竞代管理子组件
    jdglFn() {
      this.$refs.jdglListRef.showDialog({ platId: this.moneyActiveName });
    },
    // 点击年
    getYearVal(val, index) {
      this.currentYear = val;
      console.log(val);
      this.getCompeteDataList();
    },
    // 点击月
    getMonthVal(val, index) {
      this.currentMonth = val;
      console.log(val);
      this.getCompeteDataList();
    },
    jumpRouter(value) {
      if (value.indexOf("http") != -1 || value.indexOf("https") != -1) {
        window.location.href = value;
      } else {
        this.$router.push({ path: value });
      }
    },
    getDate(time) {
      //中国标准时间获取当前日
      let YY = time.getFullYear() + "-";
      let MM =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1 + "-";
      let DD = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      return YY + MM + DD;
    },
    getNowDate() {
      // 获取日历当前需要显示的 年月日[a,b]
      let y = this.currentYear; // 当前年
      // 当前月
      let m =
        this.currentMonth < 10 ? "0" + this.currentMonth : this.currentMonth;
      let nextMonthFirthDay = new Date(y, m, 1); // 下个月的第一天
      let oneDay = 1000 * 60 * 60 * 24; // 一天的时间毫秒数
      let newDay = new Date(nextMonthFirthDay - oneDay);
      let endDay = newDay.getDate(); // 本月最后一天

      let first = `${y}-${m}-01`;
      let end = `${y}-${m}-${endDay}`;
      this.range_time[0] = first;
      this.range_time[1] = end;
      return [first, end];
    },

    // 请求日历接口
    getCompeteDataList() {
      this.isLoading = true;
      let rangTime = this.getNowDate();
      this.range_time = [rangTime[0], rangTime[1]];
      let options = {
        plat_id: this.moneyActiveName,
        range_time: rangTime[0] + "/" + rangTime[1]
      };

      API.getCompeteDataList(options).then(
        res => {
          let resData = res ? res.data : {};
          this.listData = resData.list;
          this.mydata.month_not_cost_date = resData.month_not_cost_date;
          this.mydata.plat_not_cost = resData.plat_not_cost;
          this.mydata.year_not_cost_date = resData.year_not_cost_date;
          this.isLoading = false;
          this.yearColor(resData.year_not_cost_date);
          this.monthColor(resData.month_not_cost_date);
          this.platColor(resData.plat_not_cost);
        },
        err => {
          this.isLoading = false;
          this.$message.error(err.info || "请求失败");
        }
      );
    },
    // 切换渠道
    handleClick(tab, event) {
      this.moneyActiveName = tab;
      this.getCompeteDataList();

      console.log(tab, event);
    }
  }
};
</script>

<style scoped lang="scss">
.currentYearIndex {
  background-color: #fefefe;
  min-height: calc(100vh - 84px);
  font-size: 12px;

  ::v-deep .el-tabs__item.is-active {
    color: #ffffff;
    background-color: #409eff !important;
  }
}

.is-selected {
  color: red;
}

.is-nodata {
  background-color: #ffecea;
}
.is-havedata {
  background-color: #ffffff;
}

.calendar-day {
  text-align: center;
  color: #202535;
  line-height: 30px;
  font-size: 12px;
}

.is-info {
  color: #909399;
  font-size: 10px;
  margin-top: 5px;
}
.is-warning {
  color: #e6a23c;
  font-size: 10px;
  margin-top: 5px;
}
.is-danger {
  color: #f56c6c;
  font-size: 10px;
  margin-top: 5px;
}
.yearAll {
  margin-bottom: 15px;
  border-bottom: 1px solid #dcdfe6;
}
.yearBtn {
  display: inline-block;
}
.yearBtn button {
  margin-right: 10px;
  width: 66px;
}
.active {
  color: #ffffff;
  background-color: #02a7f0;
}

.jdgl {
  color: #7f7f7f;
  text-decoration: underline;
  font-size: 14px;
}
.jdgl span:hover {
  color: #02a7f0;
}

.mt15 {
  margin-top: 15px;
}
</style>

